import styled from 'styled-components'

export const StyledMessage = styled.div`
  margin: 0;
  color: ${(props) => props.color};
`
